import React, { useState, useEffect } from "react";
import { Autocomplete, TextField } from "@mui/material";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase-config";

const AddMemberAutocomplete = ({ existingMemberUids, onMemberAdded }) => {
  const [inputValue, setInputValue] = useState("");
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (!inputValue.trim()) {
      setOptions([]);
      return;
    }
    const fetchUsers = async () => {
      try {
        const snapshot = await getDocs(collection(db, "users"));
        const lowerInput = inputValue.toLowerCase();
        const results = snapshot.docs
          .map((docSnap) => {
            const data = docSnap.data();
            const fullName = `${data.firstName || ""} ${data.lastName || ""}`.trim();
            return { uid: docSnap.id, fullName };
          })
          .filter((user) => user.fullName.toLowerCase().includes(lowerInput))
          .filter((user) => !existingMemberUids.includes(user.uid));
        setOptions(results);
      } catch (error) {
        console.error("Error fetching users for autocomplete:", error);
      }
    };
    fetchUsers();
  }, [inputValue, existingMemberUids]);

  return (
    <Autocomplete
      value={null}
      inputValue={inputValue}
      onInputChange={(_, newVal) => setInputValue(newVal)}
      onChange={(_, value) => {
        if (value) onMemberAdded(value.uid);
        setInputValue("");
      }}
      options={options}
      getOptionLabel={(option) => option.fullName}
      renderInput={(params) => (
        <TextField {...params} label="Add Member by Name" variant="outlined" />
      )}
      clearOnBlur
      freeSolo={false}
    />
  );
};

export default AddMemberAutocomplete;